import Partners from "../puglins/Utils/models/partners";

// 🤝 Code partenaire de la visite (tour 54). acadeclic.fr/p/CODE ouvre l'accueil, ?via=CODE ajouté à
// n'importe quelle adresse du site fait la même chose sur cette page, puis le code disparaît de
// l'adresse affichée. Une visite est comptée côté API, une seule par chargement du site.
// Le code reste en mémoire le temps de la visite seulement : jamais de cookie, ni de localStorage, ni
// de sessionStorage (pas de question de consentement). Un rechargement de la page le perd.
// À l'inscription d'un élève, le champ « Code partenaire » est déjà ouvert et rempli. Ce que l'élève
// y tape (ou vide) remplace le code du lien, aussi pour une inscription avec Google ou Facebook.
let fromLink = null; // { code, publicName, premiumMonths } (🎁 mois de Premium offerts, tour 57)
let typed = null; // valeur du champ, null tant que l'élève n'y a pas touché
let counted = false;
const listeners = new Set();

export const partnerFromLink = () => fromLink;

// Code envoyé à l'inscription d'un élève
export const partnerCodeToSend = () => String(typed !== null ? typed : fromLink?.code || "").trim();
export const setTypedPartnerCode = (value) => {
  typed = value;
};

// Prévenu quand le code d'un lien est connu (réponse de l'API arrivée après l'affichage du champ)
export const onPartnerFromLink = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

// Arrivée par un lien : visite comptée une seule fois par chargement du site. Code inconnu : ignoré.
// Partenaire suspendu : visite comptée, rien n'est prérempli.
// 🎪 Salon sur le même Wi-Fi (tour 54, suite) : visite refusée par la limite ou sans réponse, le code du
// lien est gardé quand même (sans « De la part de… »). Une visite non comptée n'est pas grave, un élève
// inscrit sans son code l'est. L'API vérifie le code à la création du compte.
export const arriveWithPartnerCode = async (code) => {
  const linkCode = String(code || "").trim();
  if (counted || !linkCode) return fromLink;
  counted = true;
  try {
    const data = await Partners.visit(linkCode);
    if (data?.active) fromLink = { code: data.code, publicName: data.public_name, premiumMonths: Number(data.premium_months) || 0 };
  } catch (err) {
    // Code inconnu (404) : ignoré. Limite atteinte ou réseau : code gardé
    if (err?.response?.status !== 404) fromLink = { code: linkCode, publicName: "", premiumMonths: 0 };
  }
  if (fromLink) listeners.forEach((listener) => listener(fromLink));
  return fromLink;
};

// ?via=CODE d'une adresse, et la même adresse sans lui
export const viaCodeOf = (search) => new URLSearchParams(search || "").get("via") || "";
export const searchWithoutVia = (search) => {
  const params = new URLSearchParams(search || "");
  params.delete("via");
  const rest = params.toString();
  return rest ? `?${rest}` : "";
};

// Tests seulement : nouveau chargement du site
export const resetPartnerVisitForTests = () => {
  fromLink = null;
  typed = null;
  counted = false;
  listeners.clear();
};
